/**
 * Safe date parsing for API values (timestamp, created_at, visit_date, etc.).
 * Returns null for missing or invalid values; use with display "--" when null.
 */
export function safeDate(value: string | number | Date | null | undefined): Date | null {
  if (value == null) return null;
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}
